import { render, staticRenderFns } from "./CorporateCategoryEdit.vue?vue&type=template&id=a51fda68"
import script from "./CorporateCategoryEdit.vue?vue&type=script&lang=js"
export * from "./CorporateCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports